import { IconConfig } from "../types";

export const users: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 24 24",
  elements: [
    {
      type: 'path',
      d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M16 3.128a4 4 0 0 1 0 7.744",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'path',
      d: "M22 21v-2a4 4 0 0 0-3-3.87",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    {
      type: 'circle',
      cx: 9,
      cy: 7,
      r: 4,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ] as const
}
